import { env as envPublic } from '$env/dynamic/public';
import { derived, writable, type Writable, type Readable } from 'svelte/store';
import { page } from '$app/stores';

// WebView or iframe check
export const isEmbedded: Writable<boolean> = writable(false);

/**
 * Theme of the application, initialized with the publisher environment variable.
 */
export const theme: Writable<string> = writable(envPublic.PUBLIC_PUBLISHER);

/**
 * Name of the selected category.
 */
export const selectedCategoryName: Writable<string> = writable('Partnere');

/**
 * Flag to determine if promoted location should be shown.
 */
export const showPromoted: Writable<boolean | undefined> = writable(false);

/**
 * Derived store to decide if promoted content should be shown.
 */
export const showPromotedDerived: Readable<boolean> = derived(page, ($page) => {
  const params = $page.url.searchParams;
  const paramKeys = [...params.keys()];

  // 1. No query params => show promoted
  if (paramKeys.length === 0) {
    return true;
  }

  // 2. Exactly one param: filter[category] => show promoted
  if (paramKeys.length === 1 && paramKeys[0] === 'filter[category]') {
    return true;
  }

  // Otherwise => hide promoted
  return false;
});

/**
 * The currently selected sorting option.
 */
export const selectedSorting: Writable<string> = writable('');

/**
 * User geolocation data, including longitude and latitude.
 */
export interface UserGeoData {
  lon?: number;
  lat?: number;
}
export const userGeoData: Writable<UserGeoData> = writable({});

/**
 * The search query entered by the user.
 */
export const searchQuery: Writable<string> = writable('');

/**
 * Controls the visibility of the Payment Card registration modal.
 */
export const showPaymentCardRegistration: Writable<boolean> = writable(false);

/**
 * Controls the visibility of the Payment Success modal.
 */
export const showBankSuccessModal: Writable<boolean> = writable(false);

/**
 * Data related to the payment card.
 */
export interface PaymentCardData {
  cardType: string;
  bankName: string;
  viewType: number;
}

export const paymentCardData: Writable<PaymentCardData> = writable({
  cardType: '',
  bankName: '',
  viewType: 0,
});

/**
 * E-shop authentication state.
 */
export interface EshopAuthState {
  loggedIn: boolean;
}
export const eshopAuth: Writable<EshopAuthState> = writable({
  loggedIn: false,
});
